"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  StoreReview: () => StoreReview
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native = require("react-native");
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var import_unavailable = require("./unavailable");
var hybrid;
function requestReview() {
  if (import_react_native.Platform.OS !== "ios" && import_react_native.Platform.OS !== "android") throw new Error("StoreReview requires a native build");
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneStoreReview");
  return hybrid.requestReview().catch(import_nativeError.rethrowNativeError);
}
var nativeStoreReview = Object.freeze({
  requestReview
});
var StoreReview = import_react_native.Platform.OS === "ios" || import_react_native.Platform.OS === "android" ? nativeStoreReview : import_unavailable.StoreReview;
//# sourceMappingURL=index.native.js.map
